import { cleanKey } from 'src/helper/MapperHelper'

export const filterCreatedVars = (data, created) => {
  if (data) {
    return Object.entries(data)
      .filter((elem) => (elem[1].created && created) || !(elem[1].created || created))
      .reduce((accum, [k, v]) => {
        accum[k] = v
        return accum
      }, {})
  }

  return {}
}

export const getVarKeys = (parseJson, search) => {
  const key = Object.keys(parseJson).find((elem) => cleanKey(elem) === search[0])
  if (search.length > 1) {
    return key && getVarKeys(parseJson[key], search.slice(1))
  }

  return key
}

export const formatVars = (data) => {
  //re create var from JSON
  if (!data || typeof data !== 'object' || Object.keys(data).length === 0) {
    return []
  }

  const entries = Object.entries(data)

  return entries.reduce((acc, [key, value]) => {
    if (typeof value === 'number') {
      acc.push({
        value: value,
        label: key,
        search: [key],
      })
    } else if (typeof value === 'string') {
      const numberValue = parseFloat(value)

      if (!isNaN(numberValue)) {
        acc.push({
          value: numberValue,
          label: key,
          search: [key],
        })
      }
    } else {
      const formatted = formatVars(value)
      formatted.forEach((val) => {
        acc.push({
          ...val,
          search: [key, ...val.search],
        })
      })
    }

    return acc
  }, [])
}

export const formatCheckedBox = (checkedBox, operators, variablesFormat, formulas) => {
  if (Array.isArray(checkedBox) && checkedBox.length > 0) {
    let ids_used = []
    return checkedBox.map((elem) => {
      let id = getNextIndex(ids_used, operators, variablesFormat, formulas)
      ids_used.push(id)
      return {
        ...elem,
        id: id,
        isOperator: true,
        isData: true,
        operator: 'search',
      }
    })
  }
  return []
}

export const getNextIndex = (ids_used = [], operators, variablesFormat = [], formulas = []) => {
  const ids = [
    ...ids_used,
    ...getNextIndexArray(operators),
    ...getNextIndexArray(variablesFormat),
    ...getNextIndexArray(formulas),
  ].sort((a, b) => b - a)
  return ids.length ? ids[0] + 1 : 1
}

export const getNextIndexArray = (array) => {
  if (array) {
    return array.map((elem) => [elem.id, ...getNextIndexArray(elem.children)]).flat()
  }
  return []
}

export const parseDefaultVars = (formulaData, jsonMapper, setCheckedBox) => {
  const filteredVars = filterCreatedVars(formulaData.var, false)
  let selectedVars = []
  if (jsonMapper && Object.keys(jsonMapper)?.length) {
    selectedVars = { ...formulaData }

    if (Object.keys(filteredVars)?.length) {
      formulaData.var = filteredVars
    } else {
      delete selectedVars.var
    }
    selectedVars = formatVars(selectedVars).map((elem, index, originalArray) => {
      const isDuplicateLabel = originalArray.slice(0, index).some((el) => el.label === elem.label)
      if (isDuplicateLabel) {
        const pathLabel = elem.search.slice(-3).join('_')
        elem.label = pathLabel
      }

      return {
        ...elem,
        key: getVarKeys(jsonMapper, elem.search),
      }
    })
  }

  let createdVars = filterCreatedVars(formulaData.var, true)
  createdVars = Object.values(createdVars).map((elem) => ({
    ...elem,
    key: elem.label,
    search: ['var', elem.label, 'value'],
  }))
  const updatedCheckedBox = [...selectedVars, ...createdVars]
  setCheckedBox(updatedCheckedBox)
  return updatedCheckedBox
}

export const filterCheckedBox = (checkedBox, jsonMapper, setCheckedBox) => {
  const filteredCheckedBox = checkedBox
    .map((elem) => {
      if (jsonMapper && !elem.created) {
        elem.key = getVarKeys(jsonMapper, elem.search)
      }

      return elem
    })
    .filter((elem) => elem.key)
  setCheckedBox(filteredCheckedBox)
  return filteredCheckedBox
}

export const updateCheckBox = (jsonMapper, formulaData, checkedBox, setCheckedBox) => {
  if (jsonMapper) {
    if (formulaData) {
      return parseDefaultVars(formulaData, jsonMapper, setCheckedBox)
    } else if (checkedBox?.length > 0) {
      return filterCheckedBox(checkedBox, jsonMapper, setCheckedBox)
    }
  }
}

export const waitVariablesFormat = async (checkedBox, variablesFormat) => {
  return new Promise(async (resolve) => {
    const checkLength = async () => {
      if (checkedBox && variablesFormat && checkedBox.length === variablesFormat.length) {
        resolve()
        clearInterval(interval)
      }
    }

    const interval = setInterval(checkLength, 1000)
  })
}
